import { Anchor, PageHeading } from 'components/atoms';
import { Head, PageLayout } from 'components/molecules';
import { getTranslations } from 'i18n';
import type { GetStaticProps, NextPage } from 'next';
import React from 'react';
import { renderContentBlock } from 'utils';
import { useTranslation } from 'utils/hooks';
import type { RichTextComponent } from 'utils/hooks/useTranslation';

const DatenschutzPage: NextPage = () => 
{
  const translations = useTranslation('datenschutz');
  const { t } = translations;

  const richComponents: Record<string, RichTextComponent> = {
    sendinblueprivacy: <Anchor href="https://de.sendinblue.com/legal/privacypolicy" external target="_blank" />,
    microsoftprivacy: <Anchor href="https://www.microsoft.com/en-us/trust-center/privacy" external target="_blank" />,
    googleprivacy: <Anchor href="https://policies.google.com/privacy" external target="_blank" />,
    sendinblue: <Anchor href="https://de.sendinblue.com" external target="_blank" />,
    privacy: <Anchor href="mailto:datenschutz@wirtschaft.at" />,
    cookies: <Anchor href="/cookie-policy" />,
  };

  return (
    <PageLayout textContentPage>

      <Head title={t('datenschutz:meta.title')}>
        <meta name="description" content={t('datenschutz:meta.description')} />
        <meta name="keywords" content={t('datenschutz:meta.keywords')} />
      </Head>

      <PageHeading title={t('datenschutz:heading')} />

      <p>{t('datenschutz:version')}</p>

      <div className="noListStyles">
        <ol>

          {renderContentBlock('datenschutz:content', translations, richComponents, 2, 'p')}
          
        </ol>
      </div>
    </PageLayout>
  );
};

export default DatenschutzPage;

export const getStaticProps: GetStaticProps = async (ctx) =>
{
  const { locale } = ctx;
  const translations = await getTranslations(locale, 'datenschutz');
  
  return { props: { ...translations } };
};
